import React, { Component } from 'react';

import { fetchInterests, SaveInterests } from '../../utils/sideEffects';
import Spinner from '../../components/UI/Spinner';
import InterestWindow from '../../components/Account/Interest/InterestWindow';
import NewInterest from '../../components/Account/Interest/NewInterest';

class Interest extends Component {

    state = {
        contentModified: false,
        myInterests: ['Music', 'Gaming'],
        error: null,
        isLoading: false,
    }

    addInterestHandler = (interest) => {
        interest = interest.toLowerCase();
        if (interest in this.state.myInterests)
            return;
        const interests = this.state.myInterests.concat(interest);
        this.setState({ myInterests: interests, contentModified: true });
    }

    removeInterestHandler = (interest) => {
        interest = interest.toLowerCase();
        const interests = this.state.myInterests.filter(myInterest => myInterest !== interest);
        this.setState({ myInterests: interests, contentModified: true });
    }

    saveInterestsHandler = async () => {
        this.setState({ isLoading: true });
        const result = await SaveInterests(this.state.myInterests);
        if (result.status !== 200) {
            this.setState({ isLoading: false, error: result.data, contentModified: false });
        } else {
            this.setState({ isLoading: false, contentModified: false });
        }
    }

    loadInterestsHandler = async () => {
        this.setState({ isLoading: true });
        const result = await fetchInterests();
        if (result.status !== 200) {
            this.setState({ isLoading: false, error: result.data });
        } else {
            this.setState({ isLoading: false, myInterests: result.data.interests });
        }
    }

    componentDidMount() {
        this.loadInterestsHandler();
    }

    render() {

        let interestsModule = (
            <div className="interests-module">
                <h2 className="interests-module__title">Manage Interests</h2>
                {this.state.error && < p className="interests-module__error">{this.state.error.message}</p>}
                <NewInterest clicked={this.addInterestHandler} />
                <InterestWindow interests={this.state.myInterests} clicked={this.removeInterestHandler} />
                <button className="btn" onClick={this.saveInterestsHandler} disabled={!this.state.contentModified}>Save</button>
            </div >
        );

        if (this.state.isLoading) interestsModule = <Spinner />

        return interestsModule;
    }
}

export default Interest;